import { MachineDetailsTab } from '../../components/machines/MachineDetailsTab';
import type { MachineDetailTab } from '../../contexts/machineDetailTabs';
import { MachineEventsTab } from './MachineEventsTab';
import { MachineHeartbeatNote } from './MachineHeartbeatNote';
import { MachineMetricsSection } from './MachineMetricsSection';

/**
 * Pulse's own machine tabs, in Arthur's design: Details as cards, and the
 * Pulse alerts as an event log. The side panel and the compact page share
 * them, so a machine reads the same on every screen.
 */
export const MACHINE_OWN_TABS: MachineDetailTab[] = [
  {
    value: 'details',
    label: 'Details',
    render: (machine) => (
      <div
        className='bg-surface-focus-support flex flex-col gap-8 px-4 pt-4 pb-10'
      >
        <MachineHeartbeatNote state={machine.state} />
        <MachineDetailsTab machine={machine} appearance='cards' />
        <MachineMetricsSection availableSignals={machine.availableSignals} />
      </div>
    ),
  },
  {
    value: 'events',
    label: 'Events',
    render: (machine) => <MachineEventsTab machineId={machine.id} />,
  },
];
